export const MY_BOOKINGS_PATH = '/my-bookings'
